import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Loader, MetricCard, Money } from "@/components/shared";
import { Store, Factory, Package, ClipboardList, IndianRupee, Percent, CreditCard, Wallet, Users, Undo2, TrendingUp, Repeat } from "lucide-react";

export default function Overview() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/overview").then((r) => setD(r.data)).catch(() => setD({})); }, []);
  if (!d) return <Loader />;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-heading text-2xl font-semibold text-forest">Business Overview</h1>
        <p className="text-sm text-ink/60">Run VIPER OWL from one dashboard.</p>
      </div>

      <div>
        <p className="overline mb-2 text-olive">Revenue & GMV (this month)</p>
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
          <MetricCard testid="ov-gmv" label="Monthly GMV" value={<Money value={d.monthly_gmv} />} icon={IndianRupee} accent />
          <MetricCard testid="ov-txn" label="Transaction Revenue" value={<Money value={d.transaction_revenue} />} icon={Percent} accent />
          <MetricCard testid="ov-sub" label="Subscription Revenue" value={<Money value={d.subscription_revenue} />} icon={CreditCard} accent />
          <MetricCard testid="ov-settle" label="Outstanding Settlements" value={<Money value={d.outstanding_settlements} />} icon={Wallet} />
        </div>
      </div>

      <div>
        <p className="overline mb-2 text-olive">Key business metrics</p>
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
          <MetricCard testid="ov-mtr" label="Monthly Transacting Retailers" value={<span className="num">{d.monthly_transacting_retailers}</span>} icon={TrendingUp} accent />
          <MetricCard testid="ov-gmvper" label="GMV / Active Retailer" value={<Money value={d.gmv_per_active_retailer} />} icon={Users} />
          <MetricCard testid="ov-aov" label="Avg Order Value" value={<Money value={d.aov} />} icon={ClipboardList} />
          <MetricCard testid="ov-refunds" label="Refunds / Returns" value={<span className="num">{d.refunds}</span>} icon={Undo2} />
        </div>
      </div>

      <div>
        <p className="overline mb-2 text-olive">Network</p>
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
          <MetricCard testid="ov-ret" label="Registered Retailers" value={<span className="num">{d.registered_retailers}</span>} sub={`${d.verified_retailers} verified`} icon={Store} />
          <MetricCard testid="ov-mfg" label="Registered Manufacturers" value={<span className="num">{d.registered_manufacturers}</span>} sub={`${d.verified_manufacturers} verified`} icon={Factory} />
          <MetricCard testid="ov-paying" label="Paying Manufacturers" value={<span className="num">{d.paying_manufacturers}</span>} icon={Repeat} />
          <MetricCard testid="ov-products" label="Active Products" value={<span className="num">{d.active_products}</span>} icon={Package} />
          <MetricCard testid="ov-otoday" label="Orders Today" value={<span className="num">{d.orders_today}</span>} icon={ClipboardList} />
          <MetricCard testid="ov-omonth" label="Orders This Month" value={<span className="num">{d.orders_this_month}</span>} icon={ClipboardList} />
        </div>
      </div>
    </div>
  );
}
